// extracted by mini-css-extract-plugin
export default {"container":"style_container__OW1bB","text":"style_text__6Kz5W","iconBox":"style_iconBox__xU72J"};